import { useAllStaffByDesignationIdAndOfficeId } from "repositories/notes-repository";
import ReportsToCheckBoxes from "./ReportsToCheckBoxes";
import { useEffect, useMemo, useState } from "react";
import { useGetUniqueStaffsUnderOwner } from "repositories/office-repository";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import staffStyles from "../staff.module.scss";

const ReportsToCheckbox = ({
  officeId,
  ownerId,
  allFiltersRef,
  resetFilters,
  preSetter,
  globalStaffPage,
}) => {
  const [memberListSearch, setMemberListSearch] = useState("");
  const [selectedVal, setSelectedVal] = useState([]);
  const {dataAccessValues,isStaff,isOwner} = useAccountOwnerCommon();
  const canAccessThisPage = isOwner || (isStaff && (globalStaffPage?dataAccessValues?.isAdmin:true));
  const { data } = useAllStaffByDesignationIdAndOfficeId(
    [],
    officeId,
    {
      ownerId,
      IsOwnerInclude: true,
      includeAdminOffice: true,
      isDistinct: globalStaffPage,
    },
    {
      enabled: !!ownerId && !globalStaffPage && canAccessThisPage,
    }
  );
  const { data: staffList } = useGetUniqueStaffsUnderOwner(ownerId, {
    enabled: !!ownerId && globalStaffPage && canAccessThisPage,
  });
  const onSearch = (val) => {
    setMemberListSearch(val);
  };
  const allData = useMemo(
    () => (globalStaffPage ? staffList?.data : data?.data),
    [globalStaffPage, staffList, data?.data]
  );

  const memberList = useMemo(() => {
    const trimSearch = memberListSearch.trim();
    if (trimSearch.length && allData?.length) {
      return (
        allData.filter((item) => {
          const user = item?.user ? item?.user : item;
          const fullName = `${user?.firstName}${user?.lastName}`.toLowerCase();
          return fullName.includes(trimSearch);
        }) || []
      );
    }
    return allData || [];
  }, [memberListSearch, allData]);
  useEffect(() => {
    if (allData?.length && preSetter?.length) {
      setSelectedVal(
        allData?.filter((res) =>
          res?.user
            ? preSetter.includes(res.userId)
            : preSetter.includes(res.id)
        )
      );
    }
  }, [preSetter, allData]);
  const setSelection = (item) => {
    const findIndex = selectedVal.findIndex((res) => res.id === item.id);
    if (findIndex > -1) {
      setSelectedVal((prev) => prev.filter((res) => res.id !== item.id));
    } else {
      setSelectedVal((prev) => [...prev, { ...item }]);
    }
  };
  const allSelected =
    selectedVal.length >= memberList.length &&
    memberList.every((res) => selectedVal.some((resp) => res.id === resp.id));
  useEffect(() => {
    const reportToIdsArray = allFiltersRef.current?.reportToIds;
    if (reportToIdsArray) {
      const mappedArray = selectedVal.map((res) =>
        res.user ? res.userId : res.id
      );
      allFiltersRef.current.reportToIds = mappedArray;
    }
  }, [selectedVal]);
  useEffect(() => {
    if (resetFilters) {
      setSelectedVal([]);
    }
  }, [resetFilters]);
  return (
    <div className={staffStyles["sidebar-report-to-filter-list"]}>
      <ReportsToCheckBoxes
        memberList={memberList}
        memberListSearch={memberListSearch}
        onSearch={onSearch}
        inputType="checkbox"
        selectedVal={selectedVal}
        checkMultiple={(item) => selectedVal.some((res) => item.id === res.id)}
        setSelectedVal={setSelection}
        sidebarFilter
        allElement={
          <li>
            <div className="ch-checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedVal(memberList);
                    } else {
                      setSelectedVal([]);
                    }
                  }}
                  checked={allSelected}
                  name="allSelected"
                />{" "}
                <span>Select All</span>
              </label>
            </div>
          </li>
        }
      />
    </div>
  );
};
export default ReportsToCheckbox;
